import Hero from "../../shared/YasuLib/Hero/Hero";
import HeroContent from "../../shared/YasuLib/Hero/HeroContent/HeroContent";
import HeroTitle from "../../shared/YasuLib/Hero/HeroTitle/HeroTitle";
import MainContent from "../../shared/YasuLib/MainContent/MainContent";
import HeroText from "../../shared/YasuLib/Hero/HeroText/HeroText";
import ContactUsForm from "./ContactUsForm/ContactUsForm";

const Contact = () => {
  return (
    <div className="bg-midnightDark">
      <Hero className="!h-fit max-sm:pb-5 sm:pt-48 sm:pb-14">
        <HeroContent>
          <HeroTitle>Contact us!</HeroTitle>
          <HeroText className="sm:max-w-2xl !block">
            For all wholesale inquiries, photo licensing, or general inquiries, connect with us below.
          </HeroText>
        </HeroContent>
      </Hero>
      <MainContent className="max-w-2xl mx-auto pb-32">
        <ContactUsForm />
      </MainContent>
    </div>
  );
};

export default Contact;
